module.exports = __webpack_public_path__ + "assets/server.e9df1296.svg";